"use client";

import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";
import { ReactLenis, useLenis } from "@studio-freight/react-lenis";

import React from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";

interface ContextProps {
  i18n?: Record<string, string>;
  lang?: string;
  translatedUri?: { [x: string]: Record<string, string> } | null;
  setTranslatedUri?: Dispatch<
    SetStateAction<{ [x: string]: Record<string, string> } | null>
  >;
  menus?: {
    [x: string]: Record<string, unknown | Record<string, unknown>[]>[];
  };
  themeOptions?: object[];
  dict?: Record<string, Record<string, string> | any>;
  lenis?: Record<string, Record<string, string> | any>;
}

const GlobalContext = createContext<ContextProps>({
  i18n: {},
  lang: "",
  translatedUri: {},
  setTranslatedUri: (): Record<string, string>[] | null => [],
  menus: {},
  themeOptions: [],
  dict: {},
  lenis: {},
});

export const GlobalContextProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ContextProps;
}) => {
  const [translatedUri, setTranslatedUri] = useState<{
    [x: string]: Record<string, string>;
  } | null>({});

  const lang = value.lang || "";
  const i18n = value.i18n || {};
  const menus = value.menus || {};
  const themeOptions = value.themeOptions || [];
  const dict = value.dict || {};

  const lenis = useLenis(() => {
    // called every scroll
  });

  gsap.registerPlugin(ScrollTrigger);

  return (
    <GlobalContext.Provider
      value={{
        i18n,
        lang,
        translatedUri,
        setTranslatedUri,
        menus,
        themeOptions,
        dict,
        lenis,
      }}
    >
      <ReactLenis root>{children}</ReactLenis>
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
